<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="473">
    <div class="pr-8 pt-9 pl-9 pb-6 white">
      <v-row>
        <v-col cols="12">
          <p class="primary--text font-weight-bold modal-cancel__title mb-2">
            {{ title }}
          </p>
        </v-col>
        <v-col cols="12">
          <p class="darkBluishGray--text font-weight-medium mb-12 pr-8">
            {{ text }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="5" sm="3">
          <BaseButton
            v-html="'NÃO'"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal(false)"
          />
        </v-col>
        <v-col cols="5" sm="3" class="ml-5">
          <BaseButton
            v-html="'SIM'"
            class="secondary"
            width="100%"
            @click="closeModal(true)"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
export default {
  methods: {
    closeModal(value) {
      this.$emit("close", value);
    }
  },
  props: {
    title: {
      type: String,
      default: "CANCELAR SEGURADORA"
    },
    text: {
      type: String,
      default:
        "Ao cancelar a seguradora você perderá todas as suas informações. Você tem certeza que deseja cancelar?"
    }
  }
};
</script>
<style lang="sass">
.modal-cancel__
  &title
    font-size: 20px
</style>
